import { defineComponent as _defineComponent } from 'vue'
import {
  useContext,
  ref,
  computed,
  inject,
  Ref,
} from '@nuxtjs/composition-api';
import MysteryBoxExchangeDialog from '~/components/Collections/MysteryBoxExchangeDialog.vue';
import VideoPlayer from '~/components/Player/VideoPlayer.vue';
import { MuxStreamTypes } from '~/types/mux-player';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import { getItemGyriId } from '~/utils/userItem';
import { ICollectionState } from '~/store/collections/types';
import { IGyriUserItem } from '~/types/user-items';
import { IInventoryState } from '~/store/inventory/types';
import { IMysteryBox } from '~/types/collections';
import { useStore } from '~/store/composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectExpansionsHero',
  props: {
    title: null,
    slug: null
  },
  setup(__props: any) {

const props = __props as {
  title: string | undefined;
  slug: string;
};

const { store, $vuetify, i18n } = useContext();

const { dispatch } = useStore();



const docType = SanityDocumentSchema.VIDEO;
const muxStreamType = MuxStreamTypes.ON_DEMAND;
const heroVideoSlug = 'mystery-box-explainer-july-2024';

const apiLoading: Ref<boolean> = ref(true);

const projectId = computed(() => props.slug);

const projectTitle = computed(() => props.title);

const mbStore = computed<IMysteryBox[]>(() =>
  store.getters['collections/getMysteryBoxesByProjectId'](projectId.value),
);

const getProjectMysteryBoxCountByProject = computed(() => {
  const mysteryBoxes = store.getters[
    'collections/getProjectMysteryBoxCountByProject'
  ](projectId.value);
  return mysteryBoxes;
});

const hasMysteryBoxes = computed(() => mbStore.value?.length > 0);

const mbCardData = computed(() => {
  mbStore.value;
  const mbCardData = {
    logo: require('@/assets/logos/myster-box-rectangle.png'),
    title: `${i18n.tc(
      'components.collection.mysteryBoxes',
      getProjectMysteryBoxCountByProject.value ?? 0,
    )}`,
    btnText: getProjectMysteryBoxCountByProject.value
      ? i18n.t('common.cta.openNow')
      : i18n.t('common.cta.buyNow'),
    onClick: getProjectMysteryBoxCountByProject.value
      ? () => openCustomRevealForMysteryBox()
      : () => handleChangeTab('store'),
  };
  return mbCardData;
});

const changeTab = inject<(tab: string) => void>('changeTab');

const handleChangeTab = (tab: string) => {
  if (changeTab) {
    changeTab(tab);
  } else {
    throw new Error('changeTab is not provided');
  }
};

const enableCustomRevealDialog = ref(false);
const selectedCustomRevealItem = ref(null as IGyriUserItem | null);

function openCustomRevealForMysteryBox(item?: IGyriUserItem) {
  enableCustomRevealDialog.value = true;
  const mysteryBoxStoreItem = (store.state.collections as ICollectionState)
    ?.byProject?.[projectId.value]?.mysteryBoxes?.[0]?.item as IGyriUserItem;
  selectedCustomRevealItem.value = item ?? mysteryBoxStoreItem;
}

const currentGryiItem = computed(() => {
  const userItems = (store.state.inventory as IInventoryState)?.userItems;
  const item = userItems?.find?.((item) => {
    const userItemGyriId = getItemGyriId(item);
    const selectedGyriId = getItemGyriId(
      selectedCustomRevealItem.value as IGyriUserItem,
    );
    return !!userItemGyriId && userItemGyriId === selectedGyriId;
  });
  return item;
});

const customRevealDialogOpen = computed(
  () => enableCustomRevealDialog?.value && !!currentGryiItem?.value,
);

function exchangeComplete() {}

function closed() {
  dispatch('customReveal/resetCustomReveal');
  enableCustomRevealDialog.value = false;
  selectedCustomRevealItem.value = null;
}

return { __sfc: true,store, $vuetify, i18n, dispatch, props, docType, muxStreamType, heroVideoSlug, apiLoading, projectId, projectTitle, mbStore, getProjectMysteryBoxCountByProject, hasMysteryBoxes, mbCardData, changeTab, handleChangeTab, enableCustomRevealDialog, selectedCustomRevealItem, openCustomRevealForMysteryBox, currentGryiItem, customRevealDialogOpen, exchangeComplete, closed, MysteryBoxExchangeDialog, VideoPlayer }
}

})